import React, { useEffect, useState } from "react"
import TiktokProfilePicture from "./TiktokProfilePicture"
import InstagramProfilePicture from "./InstagramProfilePicture"
import ReadMore from "./ReadMore"
import "./styles/styles.css"
import { TAfindApplications } from "../services/applicationAPI"
import {
  TAbanUser,
  TAchangePhone,
  TAchangeUserBalance,
  TAdeleteUser,
  TArecoverAccount,
  TAremoveBan,
  TAremoveVerification,
  TAuserIsSpam,
  TAuserUnvisible,
  TAverifyUser,
} from "../services/userAPI"
// import { UpdateInsta } from "./updateInstaModal"
// import { UpdateTiktok } from "./updateTiktokModal"
import { InstaData, SharedPost, TiktokData, TiktokVideo, User, UserMoney } from "../types/UserData"
import VideoPlayer from "./VideoPlayer"
import { numFixer } from "../pages/User/getAllUsers/components/Functions"
import UpdateUserBalance from "./UpdateUserBalance"
import { getErrorResponse } from "../types/error"
import { ApplicationDoc } from "../types/applicationData"
import { applicationStateLabels } from "../pages/Campaign/findCampaign/FindCampaign"

type UserProfileProps = {
  user: User
}

const UserProfile: React.FC<UserProfileProps> = ({ user }) => {
  const [_id, setId] = useState(user._id)
  const [birthday, setBirthday] = useState(user.birthday)
  const [name, setName] = useState(user.name)
  const [email, setEmail] = useState(user.email)
  const [phone, setPhone] = useState(user.phone)
  const [editPhone, setEditPhone] = useState(user.phone)
  const [is_banned, setIsBanned] = useState(user.is_banned)
  const [job, setJob] = useState(user.job)
  const [country, setCountry] = useState(user.country)
  const [city, setCity] = useState(user.city)
  const [gender, setGender] = useState(user.gender)
  const [deleted, setDeleted] = useState(user.deleted)
  const [editor, setEditor] = useState(false)
  const [editBalance, setEditBalance] = useState(false)
  const [newBalance, setNewBalance] = useState(user.money?.current || 0)
  const [hobbies, setHobbies] = useState(user.hobbies)
  const [verification, setVerification] = useState(user.verification)
  // const [isUpdateInstaOpen, setIsUpdateInstaOpen] = useState(false)
  // const [isUpdateTiktokOpen, setIsUpdateTiktokOpen] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const [instaData, setInstaData] = useState<InstaData>(user.insta)
  const [sharedPostData, setSharedPostData] = useState<SharedPost[]>(user.insta?.shared_posts || [])
  const [tiktokData, setTiktokData] = useState<TiktokData>(user.tiktok)
  const [videos, setVideos] = useState<TiktokVideo[]>(user.tiktok?.videos || [])
  const [moneyData, setMoneyData] = useState<UserMoney>(user.money || {})
  const [notification, setNotification] = useState("")
  const [error, setError] = useState("")
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null)
  const [instaPricingData, setInstaPricingData] = useState<any>(user.insta?.pricing || {})
  const [tiktokPricingData, setTikTokPricingData] = useState<any>(user.tiktok?.pricing || {})
  const [operation, setOperation] = useState("")
  const [applications, setApplications] = useState<ApplicationDoc[]>([])

  const fetchUserApplications = async (userId: string) => {
    try {
      const response = await TAfindApplications(`user=${userId}`)
      if (response && Array.isArray(response)) {
        const sortedApps = response.sort(
          (a: ApplicationDoc, b: ApplicationDoc) =>
            new Date(b.application_date).getTime() - new Date(a.application_date).getTime(),
        )
        setApplications(sortedApps)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("Error fetching user applications:", error)
    }
  }

  useEffect(() => {
    if (_id) {
      fetchUserApplications(_id)
    }
  }, [_id])

  useEffect(() => {
    setId(user._id)
    setName(user.name)
    setBirthday(user.birthday)
    setEmail(user.email)
    setJob(user.job)
    setCountry(user.country)
    setCity(user.city)
    setGender(user.gender)
    setHobbies(user.hobbies)
    setMoneyData(user.money || {})
    setVerification(user.verification)
    setPhone(user.phone)
    setDeleted(user.deleted)
    setIsBanned(user.is_banned)
    setInstaPricingData(user.insta?.pricing || {})
    setTikTokPricingData(user.tiktok?.pricing || {})
    setInstaData(user.insta || {})
    setTiktokData(user.tiktok || {})
    setSharedPostData(user.insta?.shared_posts || [])
    setVideos(user.tiktok?.videos || [])
  }, [user])

  const personalInfo: { key: string; value: any }[] = [
    { key: "İsim:", value: name },
    {
      key: "Doğum Tarihi:",
      value: birthday instanceof Date ? birthday.toLocaleDateString() : birthday,
    },
    { key: "Email:", value: email },
    { key: "Meslek:", value: job },
    { key: "Ülke:", value: country },
    { key: "Şehir:", value: city },
    { key: "Cinsiyet:", value: gender },
    { key: "Hobiler:", value: hobbies?.join(", ") },
    { key: "Papara Hesap No:", value: moneyData?.paparaAccountNo },
  ]

  const instaPricingInfo: { key: string; value: any }[] = [
    { key: "Barter Fiyat (Post - TR):", value: instaPricingData.barter_price_post_tr || 0 },
    { key: "Barter Fiyat (Post - US):", value: instaPricingData.barter_price_post_us || 0 },
    { key: "Barter Fiyat (Reel - TR):", value: instaPricingData.barter_price_reel_tr || 0 },
    { key: "Barter Fiyat (Reel - US):", value: instaPricingData.barter_price_reel_us || 0 },
    { key: "Barter Fiyat (Story - TR):", value: instaPricingData.barter_price_tr || 0 },
    { key: "Barter Fiyat (Story - US):", value: instaPricingData.barter_price_us || 0 },

    { key: "Fiyat (Post - TR):", value: instaPricingData.price_post_tr || 0 },
    { key: "Fiyat (Post - US):", value: instaPricingData.price_post_us || 0 },
    { key: "Fiyat (Reel - TR):", value: instaPricingData.price_reel_tr || 0 },
    { key: "Fiyat (Reel - US):", value: instaPricingData.price_reel_us || 0 },
    { key: "Fiyat (Story - TR):", value: instaPricingData.price_tr || 0 },
    { key: "Fiyat (Story - US):", value: instaPricingData.price_us || 0 },
  ]

  const tiktokPricingInfo: { key: string; value: any }[] = [
    { key: "Barter Fiyat (TR):", value: tiktokPricingData.barter_price_tr || 0 },
    { key: "Barter Fiyat (US):", value: tiktokPricingData.barter_price_us || 0 },
    { key: "Fiyat (TR):", value: tiktokPricingData.price_tr || 0 },
    { key: "Fiyat (US):", value: tiktokPricingData.price_us || 0 },
  ]

  const warnings = instaData?.warnings?.map((warning) => warning.native_name)

  const instagramInfo: { key: string; value: any }[] = [
    { key: "Kullanıcı Adı:", value: instaData?.username },
    { key: "Tam İsim:", value: instaData?.full_name },
    { key: "Biyografi:", value: instaData?.biography },
    { key: "Takipçi:", value: instaData?.followers },
    { key: "Takip:", value: instaData?.following },
    { key: "Gönderi Sayısı:", value: instaData?.post_number },
    { key: "Ortalama Beğeni:", value: numFixer(instaData?.average_like || 0) },
    { key: "Etkileşim Oranı:", value: numFixer(instaData?.engagement_rate || 0) },
    { key: "Nesneler:", value: instaData?.keywords?.join(", ") },
    { key: "Uyarılar:", value: warnings?.join(", ") },
    { key: "Spam Durumu:", value: instaData?.is_spam ? "True" : "False" },
    { key: "Görünürlük Durumu:", value: instaData?.unvisible ? "True" : "False" },
  ]

  const tiktokInfo: { key: string; value: any }[] = [
    { key: "Kullanıcı Adı:", value: tiktokData?.username },
    { key: "Takma Ad:", value: tiktokData?.username },
    { key: "Takipçi:", value: tiktokData?.followers },
    { key: "Takip:", value: tiktokData?.following },
    { key: "Kalp Sayısı:", value: tiktokData?.hearts },
    { key: "Ortalama Beğeni:", value: numFixer(tiktokData?.tiktok_average_like) },
    { key: "Etkileşim Oranı:", value: numFixer(tiktokData?.tiktok_engagement_rate) },
  ]

  const recoverAccount = async (id: any, status: any) => {
    try {
      const response = await TArecoverAccount(id, status)
      if (response) {
        setDeleted(status)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const deleteAccount = async (id: any) => {
    try {
      const response = await TAdeleteUser(id)
      if (response && response.deleted) {
        setDeleted(true)
      } else if (
        response &&
        (response.msg === "Başvurular var" || response.err === "Başvurular var")
      ) {
        setError("Kullanıcının başvuruları mevcut, ilk önce başvurular iptal edilmeli.")
      }
    } catch (error: unknown) {
      const errorMessage = getErrorResponse(error) as string
      if (errorMessage === "Başvurular var") {
        setError("Kullanıcının başvuruları mevcut, ilk önce başvurular iptal edilmeli.")
      } else if (errorMessage) {
        setError(errorMessage)
      }
    }
  }

  const changePhone = async (id: any, phone: any) => {
    try {
      const response = await TAchangePhone(id, phone)
      setEditPhone(phone)
      if (response) {
        setPhone(phone)
        setEditor(false)
      }
    } catch (error: unknown) {
      const errorMessage = getErrorResponse(error) as string
      if (errorMessage && errorMessage.startsWith("E11000")) {
        setError("Telefon numarası mevcut, ilk önce mevcut telefon numarasını değiştirin.")
      }
    }
  }

  const rejectUser = async (id: string) => {
    try {
      const response = await TAverifyUser(id, "false")
      if (response) {
        setVerification(false)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const verifyUser = async (id: string) => {
    try {
      const response = await TAverifyUser(id, "true")
      if (response) {
        setVerification(true)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const removeVerification = async (id: string) => {
    try {
      const response = await TAremoveVerification(id)
      if (response) {
        setVerification(false)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const changeSpam = async (id: string, status: boolean) => {
    try {
      const response = await TAuserIsSpam(id, status)
      if (response) {
        setInstaData({
          ...instaData,
          is_spam: status,
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const changeUnvisible = async (id: string, status: boolean) => {
    try {
      const response = await TAuserUnvisible(id, status)
      if (response) {
        setInstaData({
          ...instaData,
          unvisible: status,
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const changeUserBalance = async (balance: number, operation: string) => {
    try {
      const response = await TAchangeUserBalance(_id, balance, operation)
      if (response) {
        setMoneyData({
          ...moneyData,
          current: balance,
        })
        setEditBalance(false)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  useEffect(() => {
    if (notification) {
      const notificationTimeout = setTimeout(() => {
        setNotification("")
      }, 5000)

      return () => clearTimeout(notificationTimeout)
    }
  }, [notification])

  useEffect(() => {
    if (error) {
      const errorTimeout = setTimeout(() => {
        setError("")
      }, 10000)

      return () => clearTimeout(errorTimeout)
    }
  }, [error])

  const handleChangePhone = (e: any) => {
    const value = e.target.value.replace(/[^0-9]/g, "")
    setEditPhone(`+${value}`)
  }

  const renderKeywords = (keywords: any) => {
    const toggleExpandedRow = () => {
      setIsExpanded(!isExpanded)
    }
    if (isExpanded) {
      return (
        <div>
          {keywords}
          <button
            type="button"
            onClick={toggleExpandedRow}
            className="text-blue-500 hover:underline"
          >
            Less
          </button>
        </div>
      )
    } else if (keywords?.length > 100) {
      return (
        <div>
          {`${keywords?.slice(0, 100)}... `}
          <button
            type="button"
            onClick={toggleExpandedRow}
            className="text-blue-500 hover:underline"
          >
            More
          </button>
        </div>
      )
    } else {
      return <div>{keywords}</div>
    }
  }

  const banUser = async (id: string) => {
    try {
      const response = await TAbanUser(id)
      if (response) {
        setIsBanned(true)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  const removeBan = async (id: string) => {
    try {
      const response = await TAremoveBan(id)
      if (response) {
        setIsBanned(false)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("error", error)
    }
  }

  return (
    <>
      <div className="profile-container p-14 rounded-lg  w-2/3 mt-14">
        <div className="flex items-center mb-20">
          <div className="flex flex-row items-center mr-16">
            <div>
              <InstagramProfilePicture instagramData={instaData} />
              {/* <button
                type="button"
                onClick={() => setIsUpdateInstaOpen(true)}
                className="btn btn-primary mt-5"
              >
                Instagramı Güncelle
              </button>

              {isUpdateInstaOpen && (
                <UpdateInsta
                  username={instaData.username}
                  _id={_id}
                  onClose={() => setIsUpdateInstaOpen(false)}
                />
              )} */}
            </div>
            <div>
              <TiktokProfilePicture tiktokData={tiktokData} />
              {/* <button
                type="button"
                onClick={() => setIsUpdateTiktokOpen(true)}
                className="btn btn-primary mt-5 ml-7"
              >
                TikToku Güncelle
              </button> */}

              {/* {isUpdateTiktokOpen && (
                <UpdateTiktok
                  username={tiktokData.username}
                  _id={_id}
                  onClose={() => setIsUpdateTiktokOpen(false)}
                />
              )} */}
            </div>
          </div>
        </div>
      </div>
      <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl">
        {notification && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-3">
            <span className="flex items-center block sm:inline">{notification}</span>
          </div>
        )}
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-3">
            <span className="flex items-center block sm:inline">{error}</span>
          </div>
        )}
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Kişisel Bilgiler</h3>
        <table className="table-responsive">
          <tbody>
            {personalInfo.map((info: { key: string; value: any }) => (
              <tr key={info.key}>
                <td>{info.key}</td>
                <td>{info.value}</td>
              </tr>
            ))}
          </tbody>
          <tbody>
            <tr>
              <td>Bakiye:</td>
              <td>{moneyData?.current || 0}</td>
              <td>
                <button
                  className="text-indigo-600 hover:text-indigo-900 pt-3"
                  onClick={() => setEditBalance(!editBalance)}
                >
                  Bakiyeyi Güncelle
                </button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>Onay Durumu:</td>
              <td>{verification ? "Onaylı" : "Onaylı Değil"}</td>
              <td>
                {verification === true ? (
                  <button
                    className="text-indigo-600 hover:text-indigo-900 pt-3"
                    onClick={() => rejectUser(_id)}
                  >
                    Onayı Kaldır
                  </button>
                ) : (
                  <button
                    className="text-indigo-600 hover:text-indigo-900 pt-3"
                    onClick={() => verifyUser(_id)}
                  >
                    Onayla
                  </button>
                )}
              </td>
              <td>
                <button
                  className="text-red-600 hover:text-red-900 pt-3 ml-4"
                  onClick={() => removeVerification(_id)}
                >
                  Onayı Sıfırla
                </button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>Telefon:</td>
              <td>{phone}</td>
              <td>
                <button
                  className="text-indigo-600 hover:text-indigo-900 pt-1 pb-1"
                  onClick={() => setEditor(!editor)}
                >
                  Telefon Numarasını Güncelle
                </button>
                {editor && (
                  <div className="flex flex-col space-y-2 pb-2">
                    <div className="flex flex-row space-x-1">
                      <input
                        id="phone"
                        type="tel"
                        placeholder="(ex: 905555555555)"
                        value={editPhone}
                        className="form-input text-sm border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 w-60 pt-1 pb-1"
                        onChange={handleChangePhone}
                      />
                      <button
                        className="text-sm font-medium text-indigo-600 hover:text-indigo-900"
                        onClick={() => changePhone(_id, editPhone)}
                      >
                        Güncelle
                      </button>
                    </div>
                  </div>
                )}
              </td>
            </tr>
            <tr>
              <td>Hesap Silinmişlik Durumu:</td>
              <td>{deleted ? "Silinmiş" : "Silinmemiş"}</td>
              <td>
                {deleted === true ? (
                  <button
                    className="text-indigo-600 hover:text-indigo-900 pt-3"
                    onClick={() => recoverAccount(_id, false)}
                  >
                    Hesabı Kurtar
                  </button>
                ) : (
                  <button
                    className="text-indigo-600 hover:text-indigo-900 pt-3"
                    onClick={() => deleteAccount(_id)}
                  >
                    Hesabı Sil
                  </button>
                )}
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td>Ban Durumu:</td>
              <td>{is_banned ? "Banlanmış" : "Banlanmamış"}</td>
              <td>
                {is_banned === true ? (
                  <button
                    className="text-indigo-600 hover:text-indigo-900 pt-3"
                    onClick={() => removeBan(_id)}
                  >
                    Ban Kaldır
                  </button>
                ) : (
                  <button
                    className="text-indigo-600 hover:text-indigo-900 pt-3"
                    onClick={() => banUser(_id)}
                  >
                    Banla
                  </button>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {moneyData?.exchanges && moneyData.exchanges.length > 0 && (
        <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl">
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">İşlem Geçmişi</h3>
          <table className="table-auto mt-4 w-full">
            <thead>
              <tr>
                <th className="px-4 py-2 text-xs text-gray-500">Operasyon</th>
                <th className="px-4 py-2 text-xs text-gray-500">Miktar</th>
                <th className="px-4 py-2 text-xs text-gray-500">Başvuru ID</th>
                <th className="px-4 py-2 text-xs text-gray-500">İşlem Tarihi</th>
              </tr>
            </thead>
            <tbody>
              {moneyData.exchanges.map((exchange, index) => (
                <tr key={index} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                  <td className="px-4 py-2 text-sm">{exchange.operation}</td>
                  <td className="px-4 py-2 text-sm">{exchange.amount}</td>
                  <td className="px-4 py-2 text-sm">{exchange.application_id || "-"}</td>
                  <td className="px-4 py-2 text-sm">
                    {new Date(exchange.action_time).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {applications && applications.length > 0 && (
        <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl">
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">Başvurular</h3>
          <div className="overflow-x-auto py-4">
            <div className="flex space-x-4">
              {applications.map((app, index) => (
                <div
                  key={index}
                  className="relative flex-shrink-0 w-64 h-[250px] p-5 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300 cursor-pointer flex flex-col justify-between"
                  onClick={() => window.open(`/campaigns/find/${app.campaign}`, "_blank")}
                >
                  <div>
                    <h3 className="text-center text-lg font-semibold text-gray-800 leading-tight min-h-[3.5rem] flex items-start justify-center pt-1">
                      {((app.campaign as any)?.name || String(app.campaign)).length > 50
                        ? ((app.campaign as any)?.name || String(app.campaign)).substring(0, 50) +
                          ".."
                        : (app.campaign as any)?.name || app.campaign}
                    </h3>
                    <div className="mt-2 flex items-center justify-center gap-2">
                      <span className="px-3 py-0.5 text-xs rounded-full bg-indigo-100 text-indigo-700 font-medium">
                        {(applicationStateLabels as any)[app.state] || app.state}
                      </span>
                    </div>
                    <div className="mt-3 flex flex-col items-center">
                      <div className="flex items-center gap-1">
                        <span className="text-sm font-medium text-gray-700">Kullanıcı Tutarı:</span>
                        <span className="text-sm font-semibold text-emerald-600">
                          {app.price_user}
                        </span>
                      </div>
                      <div className="flex items-center gap-1 mt-1">
                        <span className="text-sm font-medium text-gray-700">Marka Tutarı:</span>
                        <span className="text-sm font-semibold text-indigo-600">
                          {app.price_brand}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 text-center border-t pt-3">
                    <p className="text-xs text-gray-500 font-medium">Başvuru Tarihi</p>
                    <p className="text-xs text-gray-400 mt-1">
                      {new Date(app.application_date).toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="flex profile-section bg-white p-3 shadow-md mb-3 rounded-2xl gap-4">
        <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl w-full">
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">
            Instagram Fiyatlandırma Bilgileri
          </h3>
          <table className="table-responsive">
            <tbody>
              {instaPricingInfo.map((info: { key: string; value: any }) => (
                <tr key={info.key}>
                  <>
                    <td>{info.key}</td>
                    <td>{info.value}</td>
                  </>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl w-full">
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">
            TikTok Fiyatlandırma Bilgileri
          </h3>
          <table className="table-responsive">
            <tbody>
              {tiktokPricingInfo.map((info: { key: string; value: any }) => (
                <tr key={info.key}>
                  <>
                    <td>{info.key}</td>
                    <td>{info.value}</td>
                  </>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Instagram Bilgileri</h3>
        <table className="table-responsive">
          <tbody>
            {instagramInfo.map((info: { key: string; value: any }, index) => (
              <tr key={`instagram-info-${_id}-${index}-${info.key}`}>
                {info.key === "Spam Durumu:" ? (
                  <React.Fragment key={`spam-${_id}-${index}`}>
                    <td className="py-2 px-4 font-semibold">Spam Durumu:</td>
                    <td className="py-2 px-4">{info.value}</td>
                    <td className="py-2 px-4">
                      <button
                        className="bg-indigo-600 text-white font-medium py-1 px-3 rounded hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                        onClick={() => changeSpam(_id, !instaData.is_spam)}
                      >
                        Spam Durumunu Değiştir
                      </button>
                    </td>
                  </React.Fragment>
                ) : info.key === "Görünürlük Durumu:" ? (
                  <React.Fragment key={`visibility-${_id}-${index}`}>
                    <td className="py-2 px-4 font-semibold">Görünmezlik Durumu:</td>
                    <td className="py-2 px-4">{info.value}</td>
                    <td className="py-2 px-4">
                      <button
                        className="bg-indigo-600 text-white font-medium py-1 px-3 rounded hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50"
                        onClick={() => changeUnvisible(_id, !instaData.unvisible)}
                      >
                        Görünmezliği Değiştir
                      </button>
                    </td>
                  </React.Fragment>
                ) : info.key === "Nesneler:" ? (
                  <React.Fragment key={`keywords-${_id}-${index}`}>
                    <td className="py-2 px-4 font-semibold">Nesneler:</td>
                    <td className="py-2 px-4">{renderKeywords(info.value)}</td>
                  </React.Fragment>
                ) : (
                  <React.Fragment key={`default-${_id}-${index}`}>
                    <td>{info.key}</td>
                    <td>{info.value}</td>
                  </React.Fragment>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="profile-section bg-white p-3 shadow-md mb-3 rounded-2xl">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">TikTok Bilgileri</h3>
        <table className="table-responsive">
          <tbody>
            {tiktokInfo.map((info: { key: string; value: any }) => (
              <tr key={info.key}>
                <td>{info.key}</td>
                <td>{info.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 className="section-title text-xl font-bold my-5">Instagram Postları</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 ">
        {sharedPostData &&
          sharedPostData.length > 0 &&
          sharedPostData?.map((post, index) => (
            <div
              key={`post-${_id}-${index}-${post.id || post.media_url}`}
              className="flex flex-col bg-white rounded-lg shadow-md overflow-hidden w-full"
            >
              <div className="flex-shrink-0">
                <img
                  className="h-48 w-full object-cover zoom"
                  src={post.media_url}
                  alt={post.description}
                />
              </div>
              <div className="px-6 py-4">
                <div className="font-bold text-xl mb-2">{post.location?.name}</div>
                {post.description?.length > 150 ? (
                  <ReadMore content={post.description} maxCharacterCount={150} />
                ) : (
                  <p className="text-gray-700 text-base">{post.description}</p>
                )}
              </div>
              <div className="px-6 mt-auto pb-2">
                <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                  Beğeniler: {post.like_count}
                </span>
                <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                  Yorumlar: {post.comment_count}
                </span>
              </div>
            </div>
          ))}
      </div>
      <h2 className="section-title text-xl font-bold my-5">TikTok Videoları</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 ">
        {videos &&
          videos?.map((video, index) => (
            <div
              key={`video-${_id}-${index}-${video.media_url}`}
              className="flex flex-col bg-white rounded-lg shadow-md overflow-hidden w-full"
              onClick={() => {
                setSelectedVideo(video.media_url)
              }}
            >
              <div className="flex-shrink-0">
                <img
                  className="h-48 w-full object-cover zoom"
                  src={video.cover}
                  alt={video.description}
                />
              </div>
              <div className="p-2">
                {video.description && video.description.length > 150 ? (
                  <ReadMore content={video.description} maxCharacterCount={50} />
                ) : (
                  <p className="text-gray-700 text-sm">{video.description}</p>
                )}
              </div>
              <div className="p-2">
                <span className="inline-block bg-gray-200 rounded-full px-2 py-0.5 text-xs font-semibold text-gray-700 mr-1 mb-1">
                  Beğeniler: {video.like_count}
                </span>
                <span className="inline-block bg-gray-200 rounded-full px-2 py-0.5 text-xs font-semibold text-gray-700 mr-1 mb-1">
                  Yorumlar: {video.comment_count}
                </span>
              </div>
            </div>
          ))}
        {selectedVideo && (
          <VideoPlayer selectedVideo={selectedVideo} onClose={() => setSelectedVideo("")} />
        )}
        <UpdateUserBalance
          modalOpen={editBalance}
          onClose={() => setEditBalance(false)}
          newBalance={newBalance}
          setNewBalance={setNewBalance}
          operation={operation}
          setOperation={setOperation}
          handleChangeBalance={changeUserBalance}
        />
      </div>
    </>
  )
}

export default UserProfile
